import { render, staticRenderFns } from "./ModalClaim.vue?vue&type=template&id=a4f8c954&scoped=true"
import script from "./ModalClaim.vue?vue&type=script&lang=js"
export * from "./ModalClaim.vue?vue&type=script&lang=js"
import style0 from "./ModalClaim.vue?vue&type=style&index=0&id=a4f8c954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f8c954",
  null
  
)

export default component.exports